import React, { useState, useEffect } from "react";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CollapseableTable from "../../components/collapseAbleTable/CollapseableTable";
import { Table } from "antd";
import useGetAttributes from "../../hooks/useGetAttributes";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import useCreateAttribute from "../../hooks/useCreateAttribute";
import UseUpdate from "../../hooks/UseUpdate";
import useDeleteItem from "../../hooks/useDeleteItem";
import useFetchItems from "../../hooks/useFetchItems";
import { getAllColumns } from "./AllColumnsData";
import useModalHandlers from "../../hooks/useModalHandler";
import useChangeHandler from "../../hooks/useChangeHandler";
import useFetchContacts from "../../hooks/useFetchContacts";
import DropdownWithButton from "../../components/Dropdown/DropdownWithButton";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

const moduleNames = [
  "Employee Contact List",
  "Business Continuty",
  "Business Location Information",
  "Critical Business Documents",
  "Vendor/Supplier Contacts",
  "Client Database",
  "Business Insurance Details",
  "Remote Work Capabilities",
  "Data Backup Systems",
];

export default function BusinessContinuty() {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [moduleName, setModuleName] = useState("");
  const [attributesData, setAttributesData] = useState(null);
  const history = useHistory();

  const {
    fetchData,
    disasterAttributeData,
    formatModuleKey,
    setTableData,
    setToUpdate,
    toUpdate,
    tableData,
  } = useFetchItems(moduleNames, setLoading);
  console.log("Disaster Attributes Data", disasterAttributeData);

  // useEffect(() => {
  //   console.log("Fetched tableData:", tableData);
  //   console.log("Employee Contact List Data:", tableData.employeeContactListData);
  // }, [tableData]);

  const { createAttributes } = useCreateAttribute(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );

  const { updateRecord } = UseUpdate(
    formData,
    setFormData,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );

  const { deleteRecord } = useDeleteItem(
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { attributes, disasterAttribute } = useGetAttributes(
    moduleNames,
    setLoading
  );
  const { showModal, updateModal, viewModal, handelCloseModal } =
    useModalHandlers(
      attributes,
      setModalTitle,
      setModuleName,
      setIsModalVisible,
      setFormData,
      setAttributesData
    );
  const { handleChange, handleItemsInfoSelect } = useChangeHandler(setFormData);

  const tableDataObj = {
    "Business Continuty": tableData.businessContinutyData,
    "Employee Contact List": tableData.employeeContactListData,
    "Business Location Information": tableData.businessLocationInformationData,
    "Critical Business Documents": tableData.criticalBusinessDocumentsData,
    "Vendor/Supplier Contacts": tableData.vendorSupplierContactsData,
    "Client Database": tableData.clientDatabaseData,
    "Business Insurance Details": tableData.businessInsuranceDetailsData,
    "Remote Work Capabilities": tableData.remoteWorkCapabilitiesData,
    "Data Backup Systems": tableData.dataBackupSystemsData,
  };

  const AllColumnsData = getAllColumns(viewModal, updateModal, deleteRecord);

  const { contactList } = useFetchContacts(setLoading);

  console.log("Attributes Data:", attributes);
  console.log("Disaster Attributes:", disasterAttribute);

  const AddContact = () => {
    history.push("/client/plan");
  };
  const AddDocument = () => {
    history.push("/orgainzer/important-document");
  };

  const cleanedAttributes = Array.isArray(attributes)
    ? attributes
        .filter(
          (item) => item !== null && typeof item === "object" && item.attributes
        )
        .reduce((acc, curr) => {
          acc[curr.name] = curr.attributes;
          return acc;
        }, {})
    : {};

  console.log("formdatabusniess", formData);
  const handleFormDataUpdate = (formData) => {
    const Payload = {
      Name: formData && formData.name,
      "Phone Number": formData && formData.phoneNumber,
      Notes: formData && formData.note,
    };

    console.log("Payload to update formData bussiness:", Payload);

    setFormData((prev) => ({
      ...prev,
      ...Payload,
    }));
  };

  const collapseableTables = [
    {
      title: "Employee Contact List",
      key: 1,
    },
  ];

  return (
    <div style={{ position: "relative" }}>
      <div className="parent-title-container">
      <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
        <h2 className="parent-title">Business Continuity</h2>
        <ToolTipCreator name={"Disaster_Business_Continuity"}/>
      </div>
        <div className="parent-icon-container">
          <img
            src={helpIcon}
            alt="help icon"
            width="18.67px"
            height="18.67px"
          />
        </div>
      </div>

      {collapseableTables.map((table, idx) => (
        <CollapseableTable
          title={table.title}
          key={table.key}
          setFormData={setFormData}
          formData={formData}
          setModuleName={setModuleName}
          handleFormDataUpdate={handleFormDataUpdate}
          createAttributes={createAttributes}
          onClick={AddContact}
          options={contactList}
        >
          <Table
            columns={AllColumnsData[table.title]}
            dataSource={tableDataObj[table.title]}
          />
        </CollapseableTable>
      ))}

      {disasterAttribute && (
        <>
          <DisabilityFormCreator
            data={disasterAttribute}
            values={disasterAttributeData}
            setSubmitBody={setFormData}
          />
          <div className="handle-submit-button-container">
            <button
              className="submit-button"
              onClick={async () => {
                if (toUpdate) {
                  await updateRecord();
                } else {
                  await createAttributes();
                }
              }}
            >
              {toUpdate ? "Update" : "Submit"}
            </button>
          </div>
        </>
      )}

      {attributes && (
        <>
          <h3 style={{ fontSize: "20px" }}>Critical Business Documents</h3>
          <DisabilityFormCreator
            data={cleanedAttributes["Critical Business Documents"] || []}
            values={attributesData}
            setSubmitBody={setFormData}
          />
          <div className="handle-submit-button-container">
            <button
              className="submit-button"
              onClick={async () => {
                if (toUpdate) {
                  await updateRecord();
                } else {
                  await createAttributes();
                }
              }}
            >
              {toUpdate ? "Update" : "Apply"}
            </button>
          </div>
        </>
      )}

      {attributes && (
        <>
          <h3 style={{ fontSize: "20px" }}>Vendor/Supplier Contacts</h3>
          <DisabilityFormCreator
            data={cleanedAttributes["Vendor/Supplier Contacts"] || []}
            values={attributesData}
            setSubmitBody={setFormData}
          />
          <div className="handle-submit-button-container">
            <button
              className="submit-button"
              onClick={async () => {
                if (toUpdate) {
                  await updateRecord();
                } else {
                  await createAttributes();
                }
              }}
            >
              {toUpdate ? "Update" : "Apply"}
            </button>
          </div>
        </>
      )}

      {attributes && (
        <>
          <h3 style={{ fontSize: "20px" }}>Client Database</h3>
          <DisabilityFormCreator
            data={cleanedAttributes["Client Database"] || []}
            values={attributesData}
            setSubmitBody={setFormData}
          />
          <div className="handle-submit-button-container">
            <button
              className="submit-button"
              onClick={async () => {
                if (toUpdate) {
                  await updateRecord();
                } else {
                  await createAttributes();
                }
              }}
            >
              {toUpdate ? "Update" : "Apply"}
            </button>
          </div>
        </>
      )}

      {attributes && (
        <>
          <h3 style={{ fontSize: "20px" }}>Business Insurance Details</h3>
          <DisabilityFormCreator
            data={cleanedAttributes["Business Insurance Details"] || []}
            values={attributesData}
            setSubmitBody={setFormData}
          />
          <div className="handle-submit-button-container">
            <button
              className="submit-button"
              onClick={async () => {
                if (toUpdate) {
                  await updateRecord();
                } else {
                  await createAttributes();
                }
              }}
            >
              {toUpdate ? "Update" : "Apply"}
            </button>
          </div>
        </>
      )}
      <div>
        <CustomModal
          show={isModalVisible}
          fields={attributesData && attributesData}
          modalTitle={modalTitle}
          close={handelCloseModal}
          onChange={handleChange}
          onSelectChange={handleItemsInfoSelect}
          submitData={modalTitle !== "Update" ? createAttributes : updateRecord}
          selectedRowData={formData && formData}
          handleItemsInfoImageChange={formData}
          loading={loading}
        />
      </div>

      <NewLoader isLoading={loading} />
    </div>
  );
}
